import React, {FC} from 'react';
import styled from 'styled-components';

import {AsyncStatusesEnum} from '../../../../../../libs/shared/core/src/helpers/types/asyncStatuses';
import {AsyncLoader} from '../../../../../../libs/shared/ui/src/components/loaders/asyncLoader';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {StyledSynopsisContentDiv} from './synopsisViewer';

interface SynopsisFailedProps {
  onRetryClick: () => void;
}

const StyledErrorWrap = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const SynopsisFailed: FC<SynopsisFailedProps> = ({onRetryClick}) => (
  <StyledSynopsisContentDiv>
    <StyledErrorWrap>
      <AsyncLoader
        status={AsyncStatusesEnum.FAILED}
        size={VisualSizesEnum.LARGE}
        onRetryClick={onRetryClick}
      />
    </StyledErrorWrap>
  </StyledSynopsisContentDiv>
);
